import { useMutation } from '@tanstack/react-query';
import clientApi from '~/clientApi';

type UseGetCreatorInsights = {
  managerId?: string;
  creatorIds: string[];
};

export const useGetCreatorInsights = () => {
  return useMutation(({ managerId, creatorIds }: UseGetCreatorInsights) =>
    clientApi.managers.insights({
      id: managerId as string,
      creators: creatorIds,
      pageSize: 100,
    }),
  );
};
